import { render, staticRenderFns } from "./ViewModes.vue?vue&type=template&id=74dd76c7&"
import script from "./ViewModes.vue?vue&type=script&lang=js&"
export * from "./ViewModes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports